import React from "react";
type FormFieldProps = {
  id: string;
  name: string;
  label: string;
  type?: "text" | "email";
  autoComplete?: string;
  required?: boolean;
  dark?: boolean;
  error?: string;
};
function FormField({
  id,
  name,
  label,
  type = "text",
  autoComplete,
  required = false,
  dark = false,
  error
}: FormFieldProps) {
  const errorId = `${id}-error`;
  return <label htmlFor={id} className={`text-[15px] font-bold ${dark ? "text-pfpc-offwhite" : "text-pfpc-navy"}`} data-id="element-394" data-mp="22pxba6nqhqy9">
      {label}
      <input id={id} name={name} type={type} autoComplete={autoComplete} required={required} aria-invalid={Boolean(error)} aria-describedby={error ? errorId : undefined} className={`mt-2 min-h-[52px] w-full rounded-[10px] border px-4 text-base font-normal text-pfpc-navy focus:outline-none focus:ring-2 focus:ring-pfpc-orange ${error ? "border-pfpc-orange" : dark ? "border-pfpc-offwhite/25" : "border-pfpc-navy/25"} ${dark ? "bg-pfpc-offwhite" : "bg-[#eceae4]"}`} data-id="element-395" data-mp="1yo3e48cqz52u" />
      {error ? <span id={errorId} className={`mt-1.5 block text-[14px] leading-5 ${dark ? "text-pfpc-offwhite" : "text-pfpc-navy"}`} data-id="element-396" data-mp="3vilq41b42sit">{error}</span> : null}
    </label>;
}
export { FormField };